import 'styles/index.scss';

import { ServerSetup } from './scripts/config';
import { RequestManager } from './scripts/request-manager'
import { encodeSummarize, decodeSummarize } from './scripts/url-creator'
import { getQueryParameter } from './scripts/url-handler'
import { ViewManager } from './scripts/view-manager'
import { addButtonEventListener } from './scripts/eventListeners'
import { getAllUserInfo } from './scripts/user-info-handler'
// START  APP 

const 
    queryParameter = getQueryParameter('shareKey'),
    config = new ServerSetup(),
    requestManagerInstance = new RequestManager(),
    viewManager = new ViewManager();

let 
    shouldStartNextServerTest = true,
    serverToCheckIndex = 0;

if (queryParameter) {
    setTimeout(() =>{
        const urlInfo = decodeSummarize(queryParameter);

        viewManager.initTablesFromUrl(urlInfo.serverList);
        viewManager.updateUserInfo(urlInfo.userInfo);
    }, 0); //to initialize ejs file from webpack
}

else {
    getAllUserInfo();

    const startNextInterval = setInterval(() => {
        if (shouldStartNextServerTest) {
            if(serverToCheckIndex < config.servers.length) {
                requestManagerInstance.requestManager(config.servers[serverToCheckIndex], config.downloadsPerPing, config.timePerTestedServer);
                
                serverToCheckIndex++;
                shouldStartNextServerTest = false;
            }
            else {
                clearInterval(startNextInterval);
                
                viewManager.addSummarizeUrl(encodeSummarize());//generate URL
                addButtonEventListener();
            }
        }
    }, 250);
}       
    
export const startNextServerTest = () => {
    shouldStartNextServerTest = true;
}